import { Button, Stack, Typography } from '@mui/joy';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGeolocated } from 'react-geolocated';
import { handleError } from '../../utils/error-handling';

function DisclaimerPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isGeolocationEnabled, isGeolocationAvailable } = useGeolocated();

  const enableCamera = async () => {
    try {
      const mm = await navigator.mediaDevices.getUserMedia({ video: true });
      if (mm.active) {
        // stop the camera
        mm.getTracks().forEach(track => track.stop());
        return true;
      } else {
        return false;
      }
    } catch {
      handleError('error', t('disclaimerPage.cameraPermissionDenied'));
      return false;
    }
  };

  const enableLocation = async () => {
    if (isGeolocationEnabled && isGeolocationAvailable) {
      return true;
    } else {
      return false;
    }
  };

  const handleAccept = async () => {
    const camera = await enableCamera();
    if (!camera) {
      handleError('error', t('disclaimerPage.cameraPermissionDenied'));
      return;
    }
    const location = await enableLocation();
    if (!location) {
      handleError('error', t('disclaimerPage.locationPermissionDenied'));
      return;
    }
    navigate('/case');
  };

  return (
    <div className="p-4 flex flex-col items-center justify-center">
      <Stack direction="column" spacing={2}>
        <Typography level="h2">{t('disclaimerPage.title')}</Typography>
        <Typography level="body-md">
          {t('disclaimerPage.description')}
        </Typography>
        <Button variant="soft" color="success" size="lg" onClick={handleAccept}>
          {t('disclaimerPage.accept')}
        </Button>
      </Stack>
    </div>
  );
}

export default DisclaimerPage;
